import Flickity from 'flickity';
import select from 'dom-select';
import 'flickity-imagesloaded';
import 'flickity-fade';
import defaultOptions from './carousel-defaults';

export default (el) => {
  const ui = {
    el,
    container: select('.carousel__container', el),
    prevButton: select('.carousel__prev-button', el),
    nextButton: select('.carousel__next-button', el)
  };

  const bindPrev = (elem) => {
    ui.prevButton.addEventListener('click', (ev) => {
      ev.preventDefault();

      elem.previous(true, false);
      ui.prevButton.blur();
    });
  };

  const bindNext = (elem) => {
    ui.nextButton.addEventListener('click', (ev) => {
      ev.preventDefault();

      elem.next(true, false);
      ui.nextButton.blur();
    });
  };

  const oldCar = Flickity.data(ui.el);

  // already initialized, so bail
  if (oldCar) {
    if (ui.prevButton) {
      bindNext(oldCar);
    }

    if (ui.nextButton) {
      bindPrev(oldCar);
    }

    return;
  }

  // check if element has options as data attribute.
  const flktyData = ui.container.getAttribute('data-flickity');
  let newCar;

  if (flktyData) {
    const optObj = JSON.parse(flktyData);
    const mergedOpts = { ...defaultOptions, ...optObj };

    // eslint-disable-next-line no-new
    newCar = new Flickity(ui.container, mergedOpts);
  } else {
    // eslint-disable-next-line no-new
    newCar = new Flickity(ui.container, defaultOptions);
  }

  if (ui.prevButton) {
    bindNext(newCar);
  }

  if (ui.nextButton) {
    bindPrev(newCar);
  }
};
